import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const TradeView = () => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [autoPoll, setAutoPoll] = useState(true);

  // Filters
  const [symbol, setSymbol] = useState("");
  const [mode, setMode] = useState("");
  const [status, setStatus] = useState("");
  const [selectedUserSummary, setSelectedUserSummary] = useState(null);

  const fetchTrades = async () => {
    try {
      let queryParams = [];
      if (symbol) queryParams.push(`symbol=${symbol}`);
      if (mode) queryParams.push(`mode=${mode}`);
      if (status) queryParams.push(`status=${status}`);

      const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      const res = await axios.get(`${API_BASE_URL}/api/admin/trades${queryString}`);
      setTrades(Array.isArray(res.data) ? res.data : (res.data?.Trades?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching admin trades", err);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchTrades();
  }, [symbol, mode, status]);

  // Real-time polling every 5 seconds if enabled
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!autoPoll) return;
    const interval = setInterval(() => {
      fetchTrades();
    }, 5000);
    return () => clearInterval(interval);
  }, [autoPoll, symbol, mode, status]);

  const handleDrilldown = async (userId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/users/${userId}/trades-summary`);
      setSelectedUserSummary(res.data);
    } catch (err) {
      alert("Error fetching user drill-down");
    }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#fff" }}>Global Trade View</h2>
          <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
            Real-time feed of all paper-trading orders across all platform clients
          </p>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "13px", color: "#d1d4dc" }}>
            <input
              type="checkbox"
              checked={autoPoll}
              onChange={(e) => setAutoPoll(e.target.checked)}
            />
            🔄 Auto-Refresh (5s Live Feed)
          </label>
          <button onClick={fetchTrades} style={btnStyle}>
            Refresh Now
          </button>
        </div>
      </div>

      {/* Filters Bar */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "20px", backgroundColor: "#1e222d", padding: "14px", borderRadius: "8px", border: "1px solid #2a2e39" }}>
        <input
          type="text"
          placeholder="Filter by stock symbol..."
          value={symbol}
          onChange={(e) => setSymbol(e.target.value)}
          style={filterInputStyle}
        />
        <select value={mode} onChange={(e) => setMode(e.target.value)} style={filterInputStyle}>
          <option value="">All Trade Modes (BUY & SELL)</option>
          <option value="BUY">BUY Only</option>
          <option value="SELL">SELL Only</option>
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={filterInputStyle}>
          <option value="">All Order Statuses</option>
          <option value="COMPLETE">COMPLETE</option>
          <option value="REJECTED">REJECTED</option>
          <option value="PENDING">PENDING</option>
        </select>
      </div>

      {/* Trades Table */}
      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Loading trades...</div>
        ) : trades.length === 0 ? (
          <div style={{ padding: "30px", textAlign: "center", color: "#888" }}>No trade orders match the active filters.</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Timestamp</th>
                <th style={thStyle}>Client User</th>
                <th style={thStyle}>Symbol</th>
                <th style={thStyle}>Mode</th>
                <th style={thStyle}>Qty</th>
                <th style={thStyle}>Execution Price</th>
                <th style={thStyle}>Total Value</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {trades.map((t) => {
                const total = (t.qty * t.price) || 0;
                return (
                  <tr key={t._id} style={{ borderBottom: "1px solid #2a2e39" }}>
                    <td style={tdStyle}>{new Date(t.createdAt).toLocaleString()}</td>
                    <td style={tdStyle}>
                      <div><strong>{t.userName || "Client"}</strong></div>
                      <div style={{ fontSize: "11px", color: "#888" }}>{t.userEmail}</div>
                    </td>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#fff" }}>{t.name}</td>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: t.mode === "BUY" ? "#4184f3" : "#ef5350" }}>
                      {t.mode}
                    </td>
                    <td style={tdStyle}>{t.qty}</td>
                    <td style={tdStyle}>₹{t.price?.toFixed(2)}</td>
                    <td style={{ ...tdStyle, fontWeight: "bold" }}>₹{total.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    <td style={tdStyle}>
                      <span
                        style={{
                          padding: "3px 8px",
                          borderRadius: "12px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor: t.status === "COMPLETE" ? "rgba(76, 175, 80, 0.15)" : t.status === "REJECTED" ? "rgba(239, 83, 80, 0.15)" : "rgba(255, 152, 0, 0.15)",
                          color: t.status === "COMPLETE" ? "#4caf50" : t.status === "REJECTED" ? "#ef5350" : "#ff9800",
                        }}
                      >
                        {t.status}
                      </span>
                    </td>
                    <td style={tdStyle}>
                      <button onClick={() => handleDrilldown(t.userId)} style={smallBtnStyle}>
                        🔍 Client Portfolio
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Drill-down Modal */}
      {selectedUserSummary && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px", borderBottom: "1px solid #363c4e", paddingBottom: "10px" }}>
              <h3 style={{ margin: 0, color: "#fff" }}>Client Drill-Down: {selectedUserSummary.user?.name}</h3>
              <button onClick={() => setSelectedUserSummary(null)} style={{ background: "none", border: "none", color: "#fff", fontSize: "18px", cursor: "pointer" }}>✕</button>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "16px" }}>
              <div style={{ backgroundColor: "#1e222d", padding: "10px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#888" }}>Email & Contact</div>
                <div>{selectedUserSummary.user?.email}</div>
                <div style={{ fontSize: "11px", color: "#888", marginTop: "4px" }}>KYC Status: {selectedUserSummary.user?.kycStatus?.toUpperCase()}</div>
              </div>
              <div style={{ backgroundColor: "#1e222d", padding: "10px", borderRadius: "6px" }}>
                <div style={{ fontSize: "12px", color: "#888" }}>Wallet Available Balance</div>
                <div style={{ fontSize: "18px", fontWeight: "bold", color: "#4caf50" }}>₹{selectedUserSummary.wallet?.marginAvailable?.toLocaleString()}</div>
              </div>
            </div>

            <h4 style={{ margin: "0 0 8px 0", color: "#b2b5be" }}>Holdings ({selectedUserSummary.holdings?.length || 0})</h4>
            <div style={{ maxHeight: "150px", overflowY: "auto", marginBottom: "16px" }}>
              {(selectedUserSummary.holdings || []).map((h) => (
                <div key={h._id} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid #2a2e39", fontSize: "13px" }}>
                  <span>{h.name} (Qty: {h.qty})</span>
                  <span>Avg: ₹{h.avg} | LTP: ₹{h.price}</span>
                </div>
              ))}
            </div>

            <div style={{ textAlign: "right" }}>
              <button onClick={() => setSelectedUserSummary(null)} style={btnStyle}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

const filterInputStyle = {
  padding: "8px 12px",
  backgroundColor: "#131722",
  border: "1px solid #363c4e",
  color: "#fff",
  borderRadius: "4px",
  fontSize: "13px",
  flex: 1,
};

const btnStyle = {
  padding: "8px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "4px",
  fontWeight: "bold",
  cursor: "pointer",
};

const smallBtnStyle = {
  padding: "4px 8px",
  backgroundColor: "#2a2e39",
  color: "#b2b5be",
  border: "1px solid #363c4e",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "11px",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalContentStyle = {
  backgroundColor: "#2a2e39",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "560px",
  color: "#fff",
};

export default TradeView;
